export const FETCH_MAINTENANCES = 'FETCH_MAINTENANCES';
export const UPDATE_ACCUMULATED = 'UPDATE_ACCUMULATED';
